<p-toast position="top-center"></p-toast>
<router-outlet #mainOutlet="outlet"></router-outlet>
@if (!mainOutlet?.isActivated) {
  <app-splash-screen></app-splash-screen>
}
